<template>
	<v-menu v-model="menu" :close-on-content-click="false" transition="slide-y-transition" offset-y>
		<template #activator="{ on, attrs }">
			<label-personalizado
				:nome-campo="nomeDoCampo"
				:obrigatorio-por-padrao="isObrigatorio"
			></label-personalizado>
			<v-text-field
				underlined
				:rules="rules"
				:value="dataFormatada"
				placeholder="Informe a Data"
				readonly
				:error="error"
				:clearable="permitirLimparData"
				:errorMessages="mensagemDeErro"
				append-icon="mdi-calendar"
				v-bind="attrs"
				v-on="on"
				:disabled="disabled"
				@input="limparCampo"
			></v-text-field>
		</template>
		<v-date-picker
			:value="value"
			no-title
			color="primary"
			@input="dtPickerInput($event)"
			locale="pt-br"
			scrollable
		></v-date-picker>
	</v-menu>
</template>
<script>
import { DataUtils } from '@/core/utils'

export default {
	name: 'input-text-de-data',
	props: {
		value: {
			type: String,
			default: null,
		},
		validationRules: {
			type: Array,
			default: () => [],
		},
		nomeDoCampo: {
			type: String,
			required: true,
		},
		isObrigatorio: {
			type: Boolean,
			required: true,
		},
		disabled: {
			type: Boolean,
		},
		error: {
			type: Boolean,
			default: false,
		},
		errorMessages: {
			type: Array,
			default() {
				return []
			},
		},
		permitirLimparData: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:value'],
	data() {
		return {
			menu: null,
			rules: this.validationRules,
		}
	},
	computed: {
		dataFormatada() {
			return this.value ? this.$options.filters.formatDataFilter(this.value) : null
		},
		mensagemDeErro() {
			if (this.error === true) return this.errorMessages
			return []
		},
	},
	methods: {
		limparCampo() {
			this.$emit('update:value', '')
		},
		dtPickerInput(value) {
			this.menu = false
			this.$emit('update:value', DataUtils.setDateTimeOffSetFromDate(value))
		},
	},
}
</script>
<style lang="stylus" scoped>

.v-menu__content
	min-width auto !important
</style>
